import React from 'react'

import CompanyClientReferralsLink from '@/components/layouts/DashboardLayout/CompanyDashboardClientReferralsLayout/components/CompanyClientReferralsLink'
import PageHeader from '@/components/misc/PageHeader'
import { ROUTES } from '@/lib/routes'

type Props = Omit<React.HTMLAttributes<HTMLDivElement>, 'children'>

const ClientReferralsPageHeader: React.FC<Props> = () => {
  return (
    <>
      <PageHeader
        className="mb-6"
        title="Recommendations"
        titleIcon={<TitleIcon />}
        subtitle={
          <>
            Get recommendations from your existing clients. Give them a unique
            link and track every lead.
          </>
        }
        tabs={[
          {
            label: 'Clients',
            to: ROUTES.recommendations(),
          },
          {
            label: 'Settings',
            to: ROUTES.recommendationsSettings(),
          },
        ]}
      />

      <CompanyClientReferralsLink />
    </>
  )
}

const TitleIcon: React.FC = () => (
  <svg
    className="w-5 h-5 text-muted-foreground"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="6.5" r="3"></circle>
    <path d="M6 21v-1c0-3.3 2.7-6 6-6s6 2.7 6 6v1"></path>
    <circle cx="5" cy="9" r="2" opacity="0.5"></circle>
    <path d="M3 21v-.5c0-2.2 1-3.8 2.5-4.5" opacity="0.5"></path>
    <circle cx="19" cy="9" r="2" opacity="0.5"></circle>
    <path d="M21 21v-.5c0-2.2-1-3.8-2.5-4.5" opacity="0.5"></path>
  </svg>
)

export default ClientReferralsPageHeader
